import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface SecurityMetricCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  loading?: boolean;
  variant?: 'default' | 'destructive' | 'warning';
}

export function SecurityMetricCard({
  title,
  value,
  icon: Icon,
  loading,
  variant = 'default',
}: SecurityMetricCardProps) {
  const variantStyles = {
    default: 'text-primary',
    destructive: 'text-destructive',
    warning: 'text-amber-500',
  };

  return (
    <Card>
      <CardContent className="p-4">
        {loading ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8 w-16" />
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">{title}</p>
              <motion.p
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                className="text-2xl font-bold"
              >
                {value.toLocaleString()}
              </motion.p>
            </div>
            <div className={cn('p-2 rounded-lg bg-muted', variantStyles[variant])}>
              <Icon className="h-5 w-5" />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
